import type { FC, SVGProps } from "react";
import Ai21LabsWordmarkRaw from "./ai21-labs-wordmark.svg";
import Ai21StudioBlackRaw from "./ai21-studio-2026-black.svg";
import Ai21StudioWhiteRaw from "./ai21-studio-2026-white.svg";
import Ai21StudioGradientRaw from "./ai21-studio-gradient-union.svg";
import Ai21StudioPinkRaw from "./ai21-studio-pink.svg";

// vite-plugin-svgr turns these .svg imports into React components at runtime
// (the repo's svgr `include: "**/*.svg"`), but vite/client types a bare .svg
// default as `string`. Cast to the real component type so callers get proper
// props (className, etc.). The runtime value genuinely is this component.
export type LogoComponent = FC<
  SVGProps<SVGSVGElement> & { title?: string; titleId?: string }
>;

// COLOR CONTRACT: every logo is monochrome `fill="currentColor"`, so the
// rendered color comes from CSS `color`. File names describe intent, not a
// baked color:
//   <Ai21LabsWordmark className="text-brand-500" />  → fuchsia
//   <Ai21LabsWordmark className="text-grey-0" />     → white (on dark)
//   <Ai21LabsWordmark className="text-grey-1000" />  → near-black
// Size by setting height (width auto-scales via viewBox), e.g. `h-6`.
export const Ai21LabsWordmark = Ai21LabsWordmarkRaw as unknown as LogoComponent;
export const Ai21StudioBlack = Ai21StudioBlackRaw as unknown as LogoComponent;
export const Ai21StudioWhite = Ai21StudioWhiteRaw as unknown as LogoComponent;
export const Ai21StudioGradient =
  Ai21StudioGradientRaw as unknown as LogoComponent;
export const Ai21StudioPink = Ai21StudioPinkRaw as unknown as LogoComponent;
